<div class="new-pop">
  <h1>{{language.WHERE_ARE_YOU}}</h1>
  <a href="javascript:void(0);" (click)="onNoClick()" class="pop-cls">
    <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" viewBox="0 0 413.348 413.348"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z" />
    </svg>
  </a>

  <div class="where-bdy">
    <div class="row" *ngIf="businessDetails.search_type == '1'">
      <div class="col-md-12">
        <div class="google-combo-input-map">
          <input placeholder="search for location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
            class="goolge-input form-control" #search [(ngModel)]="searchaddress">
          <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" [disableDefaultUI]="false"
            [zoomControl]="true" (mapClick)="mapLocation($event)">
            <agm-marker [latitude]="latitude " [longitude]="longitude" (markerClick)="clickedMarker(label)"
              [markerDraggable]="draggable" (dragEnd)="markerDragEnd($event)">
              <agm-info-window>
                <strong>{{label}}</strong>
              </agm-info-window>
            </agm-marker>
            <agm-polygon *ngFor="let path of paths" [strokeColor]="color" [strokeOpacity]="0.8" [fillColor]="color"
              [fillOpacity]="0.35" [strokeWeight]="2" [paths]="path" [clickable]="false">
            </agm-polygon>
          </agm-map>
        </div>
      </div>
      <div *ngIf="zonematch == false" class="col-md-12">
        <p class="sry-txt">
          <span><i class="fa fa-frown-o" aria-hidden="true"></i>
          </span>{{language.YOUR_AREA_IS_NOT_IN_DELIVERY}}
        </p>
      </div>
    </div>
    <div class="row" *ngIf="businessDetails.search_type == '5'">
      <div class="col-md-12">
        
        <div class="google-combo-input-map">

          <div style="position: absolute;
    z-index: 999999;
    right: 15px;
    top: 10px;
    display: flex;
    gap: 10px;
    align-items: center;">

          <a  href="javascript:void(0)" (click)="ClearInputPlace()" >
            <svg width="14" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 3.5L30.1406 29.5M30.5 3.5L3.8594 29.5" stroke="#FF0000" stroke-width="7" stroke-linecap="round"/>
            </svg>

          </a>

          <a  href="javascript:void(0)" (click)="GetCurrentLocation()" ><svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.38613 0C2.41106 0 0 2.41109 0 5.38613C0 8.42244 1.50494 9.06931 3.16831 11.0891C5.15788 13.505 5.38613 16 5.38613 16C5.38613 16 5.61438 13.505 7.60394 11.0891C9.26731 9.06931 10.7722 8.42244 10.7722 5.38616C10.7722 2.41109 8.36119 0 5.38613 0ZM5.38613 7.24753C4.35809 7.24753 3.52475 6.41416 3.52475 5.38616C3.52475 4.35816 4.35813 3.52478 5.38613 3.52478C6.41412 3.52478 7.2475 4.35816 7.2475 5.38616C7.2475 6.41416 6.41412 7.24753 5.38613 7.24753Z" fill="#919191"/>
          </svg>
          </a>

          </div>
          
          <!--<input style="margin-bottom: 5px;" placeholder="search for location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
            class="goolge-input form-control" #search [(ngModel)]="searchaddress">-->

            <input style="position: relative;margin-bottom: 5px;" autocomplete="off" placeholder="search for location"  autocorrect="off" autocapitalize="off" spellcheck="off" #search [(ngModel)]="searchaddress">

             <div *ngIf="kmmatch == false" class="col-md-12">
              <p class="sry-txt">
                <span><i class="fa fa-frown-o" aria-hidden="true"></i>
                </span>{{'Delivery is not available for that location. Please chagne the order type to Pickup.'}}
              </p>
            </div>           

          <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom" [disableDefaultUI]="false"
            [zoomControl]="true" (mapClick)="mapLocation($event)">
            <agm-marker [latitude]="latitude " [longitude]="longitude" >
              <agm-info-window>
                <strong>{{label}}</strong>
              </agm-info-window>
            </agm-marker>
            
          </agm-map>
        </div>
      </div>
     
    </div>
    <div class="row" *ngIf="businessDetails.search_type == '2'">
      <div class="col-md-12">
        <div class="md-pdn1">
          <select [(ngModel)]="zipval">
            <option *ngFor="let opt of businessDetails.ziplist" value="{{opt.id}}">{{opt.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="businessDetails.search_type == '3'">
      <div class="col-md-12">
        <div class="md-pdn1">
          <select [(ngModel)]="zipval">
            <option *ngFor="let opt of businessDetails.citylist" value="{{opt.id}}">{{opt.name}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="businessDetails.search_type == '4'">
      <div class="col-md-12">
        <div class="md-pdn1">
          <select [(ngModel)]="zipval" (ngModelChange)="AreaChange($event)">
            <option *ngFor="let opt of businessDetails.arealist" value="{{opt.id}}">{{opt.name}}</option>
          </select>
        </div>
        
      </div>
       <div class="col-md-12" *ngIf="zipval > '0'">

          <div class="md-pdn1">
              <input autocomplete="off" placeholder="{{language.ADDRESS}}"  autocorrect="off" autocapitalize="off" spellcheck="off" (keyup)="placeChanged()" [(ngModel)]="sub_address" #seaddress>
          </div>
      </div>


    </div>
  </div>
  <div class="flx-btn" style="margin-top: 20px;">
    <button class="sbm-btn cmn-button" (click)="pickupSearch()" cdkFocusInitial>{{language.CHANGE_WITH_PICKUP}}</button>
    &nbsp; &nbsp;
    <button class="sbm-btn cmn-button" (click)="dineinSearch()" cdkFocusInitial>{{language.DINE_IN}}</button>

    &nbsp; &nbsp;
    <button (click)="checkWhereAreU()" class="sbm-btn cmn-button cncl-btn" cdkFocusInitial>{{language.SUBMIT}}</button>
  </div>
</div>


